import { TagsGroup } from "./TagsGroup/TagsGroup";

export class TagsGroupComponent {
  constructor(container) {
    if (!container) {
      throw new Error('Container element is required');
    }

    this.container = container;
    this.elements = this.container.querySelectorAll('[data-tags-group]');
    this.components = [];

    if (this.elements.length > 0) {
      this.init();
    }
  }

  init() {
    this.elements.forEach(element => {
      const item = new TagsGroup(element);
      this.components.push(item);
    })
  }

  dispose() {
    if(this.components.length) {
      this.components.forEach(component => {
        component.dispose();
      })
    }

    this.components = null;
    this.elements = null;
    this.container = null;
  }
}
